import React from "react";
import NextLink from "@insightfulscience/smart-react/NextLink";
import Link from "@insightfulscience/atomic-react/Link";
import Paragraph from "@insightfulscience/atomic-react/Paragraph";
import { Col } from "@insightfulscience/atomic-react/Grid";
import { ROUTE_PLASMIDS } from "../../routes";
import { correctPlasmidName } from "../../utils/plasmid/helpers";

const setProps = ({ plasmidSetName, set, plasmidSetDesc }) => ({
	id: set,
	title: plasmidSetName,
	description: plasmidSetDesc,
	selected: false,
});

const plasmidProps = (
	setID,
	currentPlasmidID,
	{ plasmidName, customMapLabel, plasmidID },
) => ({
	id: `${setID}/${plasmidID}`,
	title: correctPlasmidName({ plasmidName, customMapLabel }),
	description: "",
	selected: plasmidID === currentPlasmidID,
});

export const renderItem =
	({
		TagLink = Link,
		TagDescription = Paragraph,
		isSet = false,
		hasDescription = false,
		setID,
		colWidth,
		plasmidID,
	}) =>
	(item) => {
		const { title, description, id, selected } = isSet
			? setProps(item)
			: plasmidProps(setID, plasmidID, item);
		const spacingProps = isSet ? { py: 2 } : {};
		return (
			<Col key={id} md={colWidth} spacing={spacingProps}>
				<NextLink
					Component={TagLink}
					href={`${ROUTE_PLASMIDS}/${id}`}
					className={selected ? "text-color-red" : ""}
					dangerouslySetInnerHTML={{ __html: title }}
				/>
				{hasDescription ? (
					<TagDescription
						className="my-0"
						dangerouslySetInnerHTML={{ __html: description }}
					/>
				) : null}
			</Col>
		);
	};
